/** Compact token-count formatting shared across the spine, Drafts panel and
 *  Home cards. Matches the abbreviation style already used by
 *  ``TokenUsageDisplay`` (e.g. ``1234 → "1.2K"``, ``1_200_000 → "1.2M"``). */
export function formatTokens(count: number | null | undefined): string {
  const n = Number(count) || 0;
  if (n >= 1_000_000) {
    return `${(n / 1_000_000).toFixed(1)}M`;
  }
  if (n >= 1_000) {
    return `${(n / 1_000).toFixed(1)}K`;
  }
  return String(n);
}
